import rem from 'polished/lib/helpers/rem';
import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  root: {
    cursor: 'pointer',
    backgroundColor: theme.palette.common.white,
    borderRadius: rem(8),
    border: theme.border.main,
    padding: rem(16),
    maxWidth: '100%',
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  title: {
    flex: 1,
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
    gap: rem(4),
  },
  body: {
    marginBottom: rem(4),
  },
}));
